import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

type MutableNextLinkProps = {
  children: React.ReactNode;
  href: string;
  id?: string;
  [key: string]: any;
};

const MutableNextLink = ({
  children,
  href,
  id,
  ...props
}: MutableNextLinkProps) => {
  const [hrefState, setHrefState] = useState(href);
  const anchorRef = useRef(null);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'href'
        ) {
          setHrefState(anchorRef.current.getAttribute('href'));
        }
      });
    });

    if (anchorRef.current) {
      const hrefOnDom = anchorRef.current.getAttribute('href');
      if (hrefOnDom !== hrefState) {
        setHrefState(hrefOnDom);
      }
      observer.observe(anchorRef.current, { attributes: true });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Link href={hrefState} {...props} ref={anchorRef} data-testid={id}>
      {children}
    </Link>
  );
};

export default MutableNextLink;
